import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    pathologiesList: [],
    showAppGlobalModals: {
      recommendationsFeed: false,
      notificationsFeed: false,
      recommendationReasons: false,
      settingsPanel: false,
      sendMessage: false,
      notes: false,
      onboardingProfileMissing: false,
      patientSummarySideBar: false,
      chatPopup: false,
    },
    newNotificationsNumber: null,
  },
  getters: {
    getPathologiesList: (state) => state.pathologiesList,
    isModalOpened: (state) => (modal) => state.showAppGlobalModals[modal],
    newNotificationsNumber: (state) => state.newNotificationsNumber,
  },
  mutations: {
    setPathologiesList: (state, list) => {
      state.pathologiesList = list
    },
    toggleShowModal: (state, payload) => {
      Object.entries(payload).forEach(([key, value]) => {
        state.showAppGlobalModals[key] = value
      })
    },
    closeAllAppGlobalModals: (state) => {
      Object.keys(state.showAppGlobalModals).forEach((key) => {
        state.showAppGlobalModals[key] = false
      })
    },
    setNewNotificationsNumber: (state, newNotificationsNumber) => {
      state.newNotificationsNumber = newNotificationsNumber
    },
  },
  actions: {
    fetchPathologiesList({ commit }) {
      return Vue.$http('general/clinical/getPathologyList')
        .then(({ data }) => {
          const { pathologies } = data

          commit('setPathologiesList', pathologies)

          return pathologies
        })
        .catch((e) => {
          console.log(e)
          console.log('Error fetching pathologies list')
        })
    },
    fetchNotificationsStats: async ({ commit }) => {
      try {
        const { data } = await Vue.$http('notifications/fetchNotificationsStats')

        commit('setNewNotificationsNumber', data.unread_notifications)
      } catch (e) {
        console.error('It was not possible to fetch notifications stats.')
      }
    },
  },
}
